import React, { useState } from "react";
import { TextField } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import firebase from "firebase";
import { db } from "./firebaseConfig";

function SignUp({ allMembers }) {
  const [member, setMember] = useState({});
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!member) {
      alert("Please enter your details first");
      return;
    }

    let isUser = false;

    allMembers.map((user) => {
      if (user.mobile === member.mobile) {
        isUser = true;
      }
    });

    if (isUser) {
      alert("Already you are a member");
      history.push("/list");
      return;
    }

    db.collection("members")
      .add({
        ...member,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then(() => {
        alert("Congratulation!! Welcome to our SSAW family");
        history.push("/list");
      })
      .catch((error) => {
        alert("An error occurred. Please try again", error.message);
      });
  };

  return (
    <div className="signup p-md-5 p-2">
      <form onSubmit={handleSubmit} className="signup__form d-flex flex-column">
        <div className="m-auto text-center">
          <h4>Welcome to our Association</h4>
          <h6>Be a part of us by providing the following informations</h6>
        </div>

        <TextField
          required
          id="outlined-required"
          className="mt-3"
          label="Name"
          variant="outlined"
          onChange={(e) => setMember({ ...member, name: e.target.value })}
        />

        <TextField
          required
          className="mt-3"
          id="outlined-required"
          label="Mobile"
          variant="outlined"
          onChange={(e) => setMember({ ...member, mobile: e.target.value })}
        />
        <TextField
          required
          className="mt-3"
          id="outlined-required"
          label="Blood Group"
          variant="outlined"
          onChange={(e) => setMember({ ...member, blood: e.target.value })}
        />
        <TextField
          required
          className="mt-3"
          id="outlined-required"
          label="Institution"
          variant="outlined"
          onChange={(e) =>
            setMember({ ...member, institution: e.target.value })
          }
        />
        <TextField
          required
          className="mt-3"
          id="outlined-required"
          label="Department"
          variant="outlined"
          onChange={(e) => setMember({ ...member, department: e.target.value })}
        />
        <TextField
          required
          className="mt-3"
          id="outlined-required"
          label="Village"
          variant="outlined"
          onChange={(e) => setMember({ ...member, village: e.target.value })}
        />
        <TextField
          required
          className="mt-3"
          id="outlined-required"
          label="HSC Year"
          variant="outlined"
          onChange={(e) => setMember({ ...member, hsc: e.target.value })}
        />
        <button type="submit" className="btn-lg btn-success mt-4">
          SUBMIT FORM
        </button>
      </form>
    </div>
  );
}

export default SignUp;
